// src/pages/CompaniesDashboard.tsx - VERIFICADO
import { useCompanies } from "../hooks/useCompanies";
import { CompanyStats } from "../components/dashboard/CompanyStats";
import { CompaniesTable } from "../components/dashboard/CompaniesTable";

/**
 * Página principal do painel de controle de empresas
 */
const CompaniesDashboard = () => {
  const {
    companies,
    loading,
    error,
    stats,
    toggleCompanyStatus,
    refreshCompanies,
    updatingIds,
  } = useCompanies();

  return (
    <div className="min-h-screen bg-background text-foreground">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Cabeçalho */}
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-foreground">
            Painel de Empresas
          </h1>
          <p className="mt-2 text-muted-foreground">
            Gerencie todas as empresas cadastradas no sistema jurídico
          </p>
        </div>

        {/* Estatísticas - Layout Otimizado */}
        <CompanyStats stats={stats} loading={loading} />

        {/* Tabela de Empresas */}
        <CompaniesTable
          companies={companies}
          loading={loading}
          error={error}
          onToggleStatus={toggleCompanyStatus}
          updatingIds={updatingIds}
        />

        {/* Botão de Recarregar */}
        {error && (
          <div className="mt-6 text-center">
            <button
              onClick={refreshCompanies}
              className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-primary-foreground bg-primary hover:opacity-90 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary transition-colors duration-200"
            >
              Tentar Novamente
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default CompaniesDashboard;